import React, { useCallback } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoaderSpinner from '@wconcept/wconcept-ui-renewal/src/components/atoms/LoaderSpinner';
import MolocoRecProductList from '@components/pages/common/MolocoRecProductList';
import ProductList from '@wconcept/wconcept-ui-renewal/src/components/organisms/_list/ProductList';
import PrdcUnitItem from '@wconcept/wconcept-ui-renewal/src/components/molecules/_item/PrdcUnitItem';
import { getExclusiveEmblemProp } from '@utils/productExclusiveUtil';
import { InfiniteScrollListProps } from '../types';

const InfiniteScrollList = React.memo<InfiniteScrollListProps>(
  ({
    products,
    isMobile,
    assistData,
    myHeartList,
    appInfo,
    onClickProduct,
    onClickHeart,
    onClickMolocoProductItem,
    recommendBgColor,
    hasNextPage,
    debouncedFetchNextPage,
    totalCount,
    molocoAdProductList,
    showExclusiveEmblem,
  }: InfiniteScrollListProps) => {
    const renderItems = useCallback(
      () =>
        products.map((v, i) => {
          if (
            molocoAdProductList &&
            totalCount > 5 &&
            i === molocoAdProductList?.webPosition
          ) {
            return (
              <React.Fragment key={`${v.itemCd}-moloco`}>
                <PrdcUnitItem
                  key={v.itemCd}
                  isDesktop={!isMobile}
                  isLogin={assistData.isLogin}
                  itemCd={v.itemCd}
                  statusCd={v.statusCd}
                  finalPrice={v.finalPrice}
                  customerPrice={v.customerPrice}
                  finalDiscountRate={v.finalDiscountRate}
                  reviewScore={v.reviewScore}
                  reviewCnt={v.reviewCnt}
                  heartCnt={v.heartCnt}
                  reserveTag={v.reserveTag}
                  saleTag={v.saleTag}
                  infoTags={v.infoTags}
                  imageUrl={v.imageUrlMobile || v.productImageUrl}
                  exclusive={getExclusiveEmblemProp(v, showExclusiveEmblem)}
                  brandCd={v.brandCd}
                  brandNameKr={v.brandNameKr}
                  itemNameSub={v.itemNameSub}
                  itemName={v.itemName}
                  myHeartItem={
                    v.itemCd ? !!myHeartList?.product?.has(v.itemCd) : false
                  }
                  todayDeliveryTag={v.todayDeliveryTag}
                  colors={v.colors}
                  onClick={() => {
                    onClickProduct(v, i);
                  }}
                  onClickHeart={async (itemCd: string, isActive: boolean) =>
                    onClickHeart?.(v, isActive, i)
                  }
                />
                <MolocoRecProductList
                  list={molocoAdProductList?.items}
                  isNativeAppBoth={appInfo.isNativeAppBoth}
                  onClickItem={onClickMolocoProductItem}
                  bgColor={recommendBgColor}
                  showExclusiveEmblem={showExclusiveEmblem}
                  onClickHeart={(product, active): void => {
                    onClickHeart?.(v, active, i, 'moloco');
                  }}
                />
              </React.Fragment>
            );
          }
          return (
            <PrdcUnitItem
              key={v.itemCd}
              isDesktop={!isMobile}
              isLogin={assistData.isLogin}
              itemCd={v.itemCd}
              statusCd={v.statusCd}
              finalPrice={v.finalPrice}
              customerPrice={v.customerPrice}
              finalDiscountRate={v.finalDiscountRate}
              reviewScore={v.reviewScore}
              reviewCnt={v.reviewCnt}
              heartCnt={v.heartCnt}
              reserveTag={v.reserveTag}
              saleTag={v.saleTag}
              infoTags={v.infoTags}
              imageUrl={v.imageUrlMobile || v.productImageUrl}
              exclusive={getExclusiveEmblemProp(v, showExclusiveEmblem)}
              brandCd={v.brandCd}
              brandNameKr={v.brandNameKr}
              itemNameSub={v.itemNameSub}
              itemName={v.itemName}
              myHeartItem={
                v.itemCd ? !!myHeartList?.product?.has(v.itemCd) : false
              }
              todayDeliveryTag={v.todayDeliveryTag}
              colors={v.colors}
              onClick={() => {
                onClickProduct(v, i);
              }}
              onClickHeart={async (
                itemCd: string,
                isActive: boolean
              ): Promise<string | null | undefined | void> =>
                onClickHeart?.(v, isActive, i)
              }
            />
          );
        }),
      [
        products,
        molocoAdProductList,
        totalCount,
        isMobile,
        assistData.isLogin,
        myHeartList?.product,
        appInfo.isNativeAppBoth,
        onClickMolocoProductItem,
        recommendBgColor,
        onClickProduct,
        onClickHeart,
        showExclusiveEmblem,
      ]
    );

    return (
      <InfiniteScroll
        dataLength={products.length}
        next={debouncedFetchNextPage}
        hasMore={!!hasNextPage}
        loader={<LoaderSpinner />}
        scrollThreshold={0.8}
      >
        <ProductList>{renderItems()}</ProductList>
      </InfiniteScroll>
    );
  }
);

InfiniteScrollList.displayName = 'InfiniteScrollList';

export default InfiniteScrollList;
